export const THRESHOLDS = {
  CONSIDER_RESCAN: 2,
  PASS: 3
}